/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/274-checkmark2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M6.21 14.339L-.007 8.22l3.084-3.035L6.21 8.268l6.713-6.607 3.084 3.035-9.797 9.643zM1.686 8.22l4.524 4.453 8.104-7.976-1.391-1.369L6.21 9.935 3.077 6.852 1.686 8.221z"/>'
  }
})
